import { BasicClient } from '@/utils/httpClient'
import store from '../vuex/store'

export default class Users {
  client
  constructor() {
    this.client = new BasicClient()
  }
  firstLoginToken() {
    return this.client.exec('/users/firstLogin', 'POST')
  }
  firstLoginResetPass(password, newmail) {
    var params = {}
    if (newmail != null && newmail != '') {
      params = {
        password: password,
        newmail: newmail
      }
    } else {
      params = {
        password: password
      }
    }
    return this.client.exec('/v2/auth-mod/firstLogin', 'POST', params)
  }
  resetpass(action, args) {
    let params = { action: action }
    if (args.length > 3) {
      Object.assign(params, {
        email: args[0],
        token: args[1],
        pass: args[2],
        repass: args[3]
      })
    } else {
      Object.assign(params, { user: args[0], email: args[1] })
    }

    return this.client.exec('/users/resetPass', 'POST', params)
  }
  getResetPassInfo(token) {
    let params = {
      action: 'info',
      token: token
    }
    return this.client.exec('/users/resetPass', 'POST', params)
  }
  //Envia el mail para el reseteo de la contraseña
  resetPassRequest(user, email, performanceToken = null) {
    var params = {
      user: user,
      email: email
    }
    if (performanceToken && performanceToken !== '') {
      params.performanceToken = performanceToken
    }
    return this.client.exec('/v2/auth-mod/resetPassword', 'POST', params)
  }

  setNewPassword(token, newPass) {
    var params = {
      token: token,
      password: newPass
    }
    return this.client.exec('/v2/auth-mod/setPassword', 'POST', params)
  }

  getprofile() {
    return this.client.exec('/users/profile', 'GET')
  }

  getprofileById(idUSer) {
    return this.client.exec('/users/profile/' + idUSer, 'GET')
  }

  getprofileByIdPatchUserRelated(idUSer) {
    return this.client.exec('/users/profile/' + idUSer, 'PATCH')
  }

  //Inicio

  getUnsignedDocs(folderId) {
    return this.client.exec(`/folders/${folderId}/documents/unsigned`, 'GET')
  }
  getActiveBoards() {
    let body = {
      orders: { field: 'id', direction: 'desc' }
    }
    return this.client.exec('/board/news/active', 'POST', body)
    // return this.client.exec('/v2/admin-mod/digitalposts', 'GET')
  }
  getDocumentBoard(id) {
    return this.client.getImage(`/board/file/${id}`, 'GET')
    // return this.client.getImage(`/v2/admin-mod/digitalposts/${id}/file`, 'GET')
  }

  //Fin Inicio

  // documentos
  getFolders() {
    return this.client.exec('/folders/available', 'POST')
  }
  getDocuments(folderId) {
    const user = store.state.user
    let numResults = (user.empresa.id === 302) ? 4000 : 600;
    
    return this.client.exec(
      `/folders/${folderId}/documents/available?pagination=${numResults},1,0`,
      'POST'
    )
  }
  getDocumentTypes() {
    return this.client.exec('/folders/documentTypes/available', 'POST')
  }
  getDocumentPages(idapp, iddoc) {
    return this.client.exec(`/documents/pages/${idapp}/${iddoc}`, 'GET')
  }
  getDocumentInfo(idapp, iddoc) {
    return this.client.exec(`/documents/info/${idapp}/${iddoc}`, 'GET')
  }
  // showDocumentView(idapp, iddoc, pages){
  //     return this.client.getImage(`/documents/view/${idapp}/${iddoc}/png/1`)
  // }
  showDocumentView(idapp, iddoc, pages) {
    return this.client.getImage(
      `/documents/view/${idapp}/${iddoc}/png/${pages}?hash=` + Date.now()
    )
  }
  showPdfDownload(idapp, iddoc) {
    return this.client.getImage(`/documents/view/${idapp}/${iddoc}/pdf/`)
  }

  getDocumentFile(idapp, iddoc) {
    return this.client.getImage(`/documents/view/cache/${idapp}/${iddoc}`)
  }

  showXmlDownload(idapp, iddoc) {
    return this.client.getImage(`/documents/view/${idapp}/${iddoc}/xml/`)
  }
  //fin documentos

  //configuracion

  getUsersRelated() {
    return this.client.exec('/users/related', 'GET')
  }

  getCompanyLogo(id_company) {
    return this.client.getPublicImage(id_company)
  }

  switchcompany(idu) {
    return this.client.exec('/users/profile/' + idu, 'PATCH')
  }

  logOut() {
    return this.client.exec('/v2/auth-mod/logout', 'POST')
  }

  validPass(pwd) {
    return this.client.exec('/users/isValidPass', 'POST', { pass: pwd })
  }

  firstlogin() {
    return this.client.exec('/users/firstLogin', 'POST')
  }

  uploadAvatarImage(formData, id) {
    return this.client.exec(
      `/users/${id}/avatar?imagen=0`,
      'POST',
      { myfile: formData },
      true
    )
  }

  getAvatarImage(id) {
    return this.client.exec(`/users/${id}/avatar`, 'GET', {
      imagen: 0
    })
    // return this.client.getImage('/users/profile/avatarMobile');
  }

  cropAvatar(imageId, data) {
    let params = {
      image: imageId,
      width: data.width,
      height: data.height,
      x: data.x,
      y: data.y
    }
    return this.client.exec('/users/profile/avatar', 'PATCH', params)
  }

  changePass(oldpass, pass, repass, send_mail = 1) {
    let params = {
      oldpass: oldpass,
      pass: pass,
      repass: repass,
      send_mail: send_mail
    }
    return this.client.exec('/users/changePass', 'PUT', params)
  }

  changePassV2(oldpass, pass, repass) {
    let params = {}
    if (oldpass) {
      params.oldpass = oldpass
    }
    if (pass) {
      params.pass = pass
    }
    if (repass) {
      params.repass = repass
    }
    return this.client.exec('/v2/admin-mod/users/changePass', 'PUT', params)
  }

  changeMail(pass, email) {
    let params = {
      pass: pass,
      email: email
    }
    return this.client.exec('/users/profile', 'PUT', params)
  }

  searchUsers(value) {
    let words = value.split(' ')
    let filter = []
    for (let i = 0; i < words.length; i++) {
      filter.push({
        operator: 'OR',
        fields: [
          {
            operator: 'con',
            alias: 'nombre',
            value: words[i]
          },
          {
            operator: 'con',
            alias: 'apellido',
            value: words[i]
          },
          {
            operator: 'con',
            alias: 'cuil',
            value: words[i]
          }
        ]
      })
    }

    let where = {
      where: filter
    }
    let params = {
      fields: 'id,usuario,nombre,apellido',
      filters: where
    }
    return this.client.exec('/search/usuario', 'POST', params)
  }

  searchUsersv2(value) {
    return this.client.exec(`/v2/admin-mod/users/searchactive`, 'GET', {
      filter: value
    })
  }

  getAnniversaries() {
    return this.client.exec('/users/anniversaries', 'GET')
  }

  getBirthdays() {
    return this.client.exec('/users/birthdays?option=1', 'GET')
  }

  getAbsents() {
    return this.client.exec('/v2/user-mod/licenses/absentUsers', 'GET')
  }

  getRecentHired() {
    return this.client.exec('/users/recentHired', 'GET')
  }

  getSector() {
    return this.client.exec('/users/retrieveSector', 'GET')
  }

  getLocacion() {
    return this.client.exec('/users/retrieveLocation', 'GET')
  }

  getPosition() {
    return this.client.exec('/v2/admin-mod/users/position', 'GET')
  }

  getSectorLocacion() {
    return this.client.exec('/users/filterSectorLocations', 'GET')
  }

  changeMailResetPass(userId, email) {
    return this.client.exec(`/users/profile/${userId}`, 'PUT', {
      email: email
    })
  }

  getEmployeePortalNotify() {
    return this.client.exec('/notifications/employeeportal', 'GET')
  }

  applicationsSAML() {
    return this.client.exec('/v2/saml/applications', 'GET')
  }

  getTotalDocuments() {
    return this.client.exec('/v2/users/documentsall/totaldocuments', 'GET')
  }

  getDownloadAvailable() {
    return this.client.exec('/v2/users/documentsall', 'GET')
  }

  requestDownloadDocuments(body) {
    return this.client.exec('/v2/users/documentsall', 'POST', body)
  }

  getDownloadFile() {
    return this.client.exec('/v2/users/documentsall/download', 'GET')
  }

  requestDownloadDocumentsReject(taskid) {
    return this.client.exec('/v2/users/documentsall/' + taskid, 'PATCH')
  }

  saveIndentifyInfo(body) {
    return this.client.exec('v2/selfservice/me', 'POST', body, true)
  }

  saveAddressInfo(body) {
    return this.client.exec('v2/selfservice/address', 'POST', body)
  }

  saveBankInfo(body) {
    return this.client.exec('v2/selfservice/bank', 'POST', body)
  }

  saveContactInfo(body) {
    return this.client.exec('v2/selfservice/contact', 'POST', body)
  }

  cancelSelfServiceRequest(id) {
    return this.client.exec(`v2/selfservice/${id}`, 'DELETE')
  }

  getServiceAllInfo() {
    return this.client.exec('v2/selfservice/all', 'GET')
  }

  getUserPhoto() {
    return this.client.getArrayBuffer('/v2/selfservice/me/photo');
  }

  getCertificateURL(id) {
    return this.client.exec('/v2/selfservice/certificate', 'POST', { id })
  }

  getCertificateRequested() {
    return this.client.exec('/v2/selfservice/certificate/history', 'GET')
  }
  getCertRequestedHistory(id) {
    return this.client.exec(`/v2/selfservice/certificate/history/${id}/download`, 'GET')
  }

  getUserDocuments() {
    return this.client.exec('/v2/inbox/documents', 'GET')
  }

  getUserDocumentsSigned(params = {}) {
    return this.client.exec('/v2/inbox/documents/signed', 'GET', params)
  }

  getUserDocumentsUnSigned(params = {}) {
    return this.client.exec('/v2/inbox/documents/unsigned', 'GET', params)
  }

  timeManagementApplication() {
    return this.client.exec('/externalapis/time_management/token', 'GET')
  }

  getFoldersPublished() {
    return this.client.exec('/v2/folders/documents/published', 'GET')
  }

linkKeycloak(falabellaJWT) {
    const payload = { strJWT: falabellaJWT };
    return this.client.exec(`/v2/keycloak/link`, 'POST', payload);
}
}
